import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SecurityService from '../../services/SecurityService';
import { translate } from '../../utils/util';
import PlantService from '../../services/PlantService';
import SelectNew from './SelectNew';
import { getVision } from '../../services/auth';
import { VISIONS } from '../../utils/constants';

const SelectShedUI = (props) => {
    const [sheds, setSheds] = useState([]);

    useEffect(() => {
        if (!props.sheds || props.sheds.length <= 0) {
            props.searchSheds(getVision());
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.unload) {
            setSheds([...props.shedsUnload]);
        } else {
            var filteShed = filterDuplicate();
            setSheds([...filteShed])
        }
        setShed(props.value);
        // eslint-disable-next-line
    }, [props.sheds, props.shedsUnload, props.value]);

    const setShed = (value) => {
        var shed = props.sheds.find((i) => i.id === value || '');
        if (shed) {
            props.setShed(value, shed);
        }
    }

    const filterDuplicate = () => {
        let unique = [];
        props.sheds.map(x => unique.filter(a => a.areaId === x.areaId).length > 0 ? null : unique.push(x));
        if (props.modality) {
            unique = unique.filter(f => f.units.filter(f => f.modalityId === props.modality).length > 0);
        }
        return unique;
    }

    const onChange = (evt) => {
        setShed(evt.target.value)
        if (props.onChange) {
            props.onChange(evt);
        }
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'shed'}
            name={props.id || 'shed'}
            label={getVision() === VISIONS.Jeep ? translate('line-picking:linepicking.area') : translate('shed', 'physical-confirmation')}
            placeHolder={translate('choose-one-option', 'general')}
            data={sheds}
            value={props.value}
            valuefield="codAux"
            display="description"
            change={onChange}
            disabled={props.disabled}

        />
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        shedsUnload: state.configReducer.shedsUnload,
        shed: state.configReducer.shed,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setShed: (shed, shedObj) => {
            dispatch(SecurityService.setShed(shed, shedObj));
        },
        searchSheds: (vision) => {
            dispatch(PlantService.searchSheds(vision));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectShedUI));
